import BrandIconBlack from '@/components/icons/brand-icon-black';
import BrandIconGreen from '@/components/icons/brand-icon-green';
import { Link } from '@tanstack/react-router';

const ExetelLogo = ({ isGreen = false }: { isGreen?: boolean }) => {
  return (
    <div data-component="CMSExetelLogo" className="flex justify-center mb-8">
      <Link to="/">
        {isGreen ? (
          <BrandIconGreen className="w-[93px] h-6 md:w-[124px] md:h-8" />
        ) : (
          <BrandIconBlack className="w-[93px] h-6 md:w-[124px] md:h-8" />
        )}
      </Link>
    </div>
  );
};

export { ExetelLogo };
